module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.content.scontests.images) ? _c('div', {
    staticClass: "home-welcome home-sponsor"
  }, [_c('div', {
    staticClass: "home-welcome__header"
  }, [_c('div', {
    staticClass: "home-welcome__header-title"
  }, [_vm._v(_vm._s(_vm.content.swelcome.heading))])]), _c('div', {
    staticClass: "home-welcome__logo-row"
  }, [_c('div', {
    staticClass: "home-welcome__logos-box"
  }, _vm._l((_vm.content.scontests.images), function(icon) {
    return (icon.link) ? _c('div', {
      staticClass: "home-welcome__logos-box-listing"
    }, [_c('a', {
      staticClass: "footer-main__addy",
      attrs: {
        "title": icon.image.title,
        "href": icon.link,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "home-welcome__logos",
      attrs: {
        "title": icon.image.title,
        "src": icon.image.url,
        "alt": icon.image.alt
      }
    })])]) : _c('div', {
      staticClass: "home-welcome__logos-box-listing"
    }, [_c('img', {
      staticClass: "home-welcome__logos",
      attrs: {
        "title": icon.image.title,
        "src": icon.image.url,
        "alt": icon.image.alt
      }
    })])
  }), 0)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a087fac","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-sponsor-welcome/custom-sponsor-welcome.pug
// module id = 633
// module chunks = 1